import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import Level1 from '../scenes/Level1';
import Title from '../scenes/Title';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class Bubbles {
  /**
   * 
   * @param {Title | Level1} scene 
   */
  constructor(scene) {
    this.scene = scene;
    this.bubbles = [];

    this.counter = 0;

    this.masker = null;

    this.setup();
  }

  setup () {
    this.createShader();
    this.createBubbles();
  }

  createShader () {
    this.masker = this.scene.add.rectangle(0,0,this.scene.scale.width, this.scene.scale.height, 0x204497).setOrigin(0);
    this.masker.alpha = 0;

    ABCyaPhaser.Tweens.addTween(this.masker, 2000, { alpha: 1 }, Phaser.Math.Easing.Linear, () => this.hideShader());
  }

  createBubbles () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._bubbles_transition, this.scene);

    for (let i = 0; i < 100; i++) {
      const startY = Phaser.Math.Between(this.scene.scale.height + 200, this.scene.scale.height);
      const bubble = ABCyaPhaser.Images.addImage(-100 + Phaser.Math.Between(0, this.scene.scale.width), startY, UIAssetKeys._2_Transition_Screen_TranstionBbl, this.scene).setOrigin(0);

      bubble.setScale(Phaser.Math.FloatBetween(0.5, 1.5));

      const speed = Phaser.Math.Between(1000, 2000);
      const randY = Phaser.Math.Between(-bubble.height, this.scene.scale.height);

      this.bubbles.push(bubble);
      ABCyaPhaser.Tweens.addTween(bubble, speed, { y: randY }, Phaser.Math.Easing.Sine.In, () => this.removeBubbles(bubble));
    }
  }

  hideShader () {
    this.scene.cleanUp();
    ABCyaPhaser.Tweens.addTween(this.masker, 2000, { alpha: 0 }, Phaser.Math.Easing.Linear);
  }

  /**
   * 
   * @param {Phaser.GameObjects.Image} bubble 
   */
  removeBubbles (bubble) {
    const speed = Phaser.Math.Between(1000, 2000);
    const randY = Phaser.Math.Between(-bubble.height, -bubble.height - 200);

    ABCyaPhaser.Tweens.addTween(bubble, speed, { y: randY }, Phaser.Math.Easing.Back.In, () => this.destroyBubble(bubble));
  }

  /**
   * 
   * @param {Phaser.GameObjects.Image} bubble 
   */
  destroyBubble (bubble) {
    bubble.destroy();

    this.counter++;

    if (this.counter === 100) {
      let lvl;
      if (gameData.config.level === 5) {
        lvl = Title.KEY;
      }
      else {
        lvl = `Level${gameData.config.level}`;
      }

      this.scene.scene.start(lvl);
    }
  }
}